<template>
  <div class="content">
    <van-popup
      v-model="showDialog"
      class="custom-popup"
      :close-on-click-overlay="false"
    >
      <van-icon
        style="margin: 20px 0 0 20px"
        @click="goBack"
        name="arrow-left"
        size="20"
        color="#1F2A47"
      />
      <div class="show-bg">
        <div class="show-bg--i" @click="goTo">
          {{ $lang.common_txt21 || 'Contacter le service client' }}
        </div>
        <div v-if="csLinkError" class="read-error">{{ csLinkError }}</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { GetCsLink } from '@/api/common'
import { openCustomerServiceUrl } from '@/views/layout/csLink'
import { customerServiceFailMessage } from '@/views/layout/csLink'

export default {
  name: 'joinUs',
  data() {
    return {
      showDialog: true,
      csLinkError: ''
    }
  },
  mounted() {},
  methods: {
    async goTo() {
      try {
        const data = await GetCsLink()
        const opened = openCustomerServiceUrl(data, 'telegram')
        if (opened) {
          this.csLinkError = ''
          return
        }
        this.csLinkError = customerServiceFailMessage(
          data,
          (this.$lang && this.$lang.feature_unavailable) || 'Cette fonctionnalité est temporairement indisponible. Veuillez réessayer plus tard.'
        )
        if (this.$toast) {
          this.$toast({
            message: this.csLinkError,
            icon: 'cross'
          })
        }
      } catch (e) {
        this.csLinkError = customerServiceFailMessage(
          e,
          (this.$lang && this.$lang.feature_unavailable) || 'Cette fonctionnalité est temporairement indisponible. Veuillez réessayer plus tard.'
        )
        if (this.$toast) {
          this.$toast({
            message: this.csLinkError,
            icon: 'cross'
          })
        }
        return
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  background: #000000;
  height: 100vh;
}
.custom-popup {
  width: 100%;
  background: transparent;
  height: 100%;
}
.show-bg {
  background: url(../../../assets/img/home/banner.png) no-repeat;
  width: 100%;
  height: 500px;
  background-size: 100% 100%;
  margin-top: 20%;
  position: relative;
}
.show-bg--i {
  background: url(../../../assets/img/home/btn2.png) no-repeat;
  width: 60%;
  height: 55px;
  background-size: 100% 100%;
  position: absolute;
  left: 25%;
  top: 395px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  font-size: var(--vk-fs-base);
}
.read-error {
  position: absolute;
  left: 10%;
  right: 10%;
  top: 460px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
  text-align: center;
}
</style>
